
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signup",
      function () {
        return require("private-next-pages/auth/signup.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/signup"])
      });
    }
  